import SignIn from '../pages/signin';
import SignUp from '../pages/signup';
import Profile from '../pages/profile';
import AllPosts from '../pages/managePosts';
import AllUsers from '../pages/manageUsers';
import Dashboard from '../pages/dashboard';
import BuyAndSell from '../pages/buy-sell';
import Wallet from '../pages/wallet';
import PassBook from '../pages/passbook';
import Login from '../pages/login';
import CustomerPage from '../pages/customer';
import CustomerOnboardingPage from '../pages/customer-onboarding';
import ResetPassword from '../pages/resetPassword';
//new
import ForcePassword from '../pages/forcePassword';
import EnterpriseSignup from 'pages/signup/enterprise';
import EntResetPassword from 'pages/resetPassword/enterprise_reset';
import AccountSelection from 'pages/account/accountSelection';
import withIdleTimer from 'shared/withIdleTimer/withIdleTimer';

//new screen 07-june-2023
import SipPage from 'pages/sip';
import SipSavingPlan from 'pages/sip/sipSavingPlan';
import PaymentSchedule from 'pages/sip/PaymentSchedule';
import GiftModule from 'pages/gift-module';
import ChartComponent from 'pages/priceCharts/ChartComponent';
import SipRedirection from 'shared/common/sipRedirection/SipRedirection';
import Undertaking from 'pages/referral-undertaking';

const commonRouteMap = {
  SipRedirectPage: {
    path: '/manualSipData/:id',
    component: SipRedirection,
  },
};
const publicRouteMap = {
  SignIn: {
    path: '/signin',
    component: Login,
  },
  LandingPage: {
    path: '/',
    component: Login,
  },
  ReferralUndertaking: {
    path: '/undertaking',
    component: Undertaking,
  },
  SignUp: {
    path: '/signup',
    component: SignUp,
  },
  Enterprise: {
    path: '/enterprise',
    component: EnterpriseSignup,
  },
  ForgetPassword: {
    path: '/reset-password',
    component: ResetPassword,
  },
  //new
  ForcePassword: {
    path: '/change-password',
    component: ForcePassword,
  },
  EntForgetPassword: {
    path: '/ent-reset-password',
    component: EntResetPassword,
  },
};

const privateRouteMap = {
  Customers: {
    path: '/customers',
    component: withIdleTimer(CustomerPage),
  },
  Accounts: {
    path: '/accounts',
    component: withIdleTimer(AccountSelection),
  },
  CustomerCreate: {
    path: '/customer/create',
    component: withIdleTimer(CustomerOnboardingPage),
  },
  Profile: {
    path: '/profile',
    component: withIdleTimer(Profile),
  },
  //sip plan
  SipPlan: {
    path: '/sip-plan',
    component: withIdleTimer(SipSavingPlan),
  },
  SipPaymentSchedule: {
    path: '/sip-payment-schedule/:id',
    component: withIdleTimer(PaymentSchedule),
  },
};

const customerRouteMap = {
  Dashboard: {
    path: '/dashboard',
    component: withIdleTimer(Dashboard),
  },
  PriceCharts: {
    path: '/price-charts',
    component: withIdleTimer(ChartComponent),
  },
  BuySell: {
    path: '/buy-sell',
    component: withIdleTimer(BuyAndSell),
  },
  Wallet: {
    path: '/wallet',
    component: withIdleTimer(Wallet),
  },
  AddPost: {
    path: '/passbook',
    component: withIdleTimer(PassBook),
  },
  //sip
  Sip: {
    path: '/sip',
    component: withIdleTimer(SipPage),
  },
  Gift: {
    path: '/gift',
    component: withIdleTimer(GiftModule),
  },
};

const adminRouteMap = {
  AllUsers: {
    path: '/users',
    component: AllUsers,
  },
};

export {
  commonRouteMap,
  publicRouteMap,
  privateRouteMap,
  customerRouteMap,
  adminRouteMap,
};
